import { NavigateFunction } from "react-router-dom";
import { TFunction } from "i18next";
import { Button, Text } from "@pentabd/ui";

import { ROUTES } from "@constants/routes";
import { IconEdit01, IconTrash01 } from "@pentabd/icons";
import { AnnualProcurementType } from "@type/procurements/annualProcurementPlan";

export const AnnualProcurementTableColumn = (
  t: TFunction<"translation", undefined>,
  getAccess: (roles: string[], roleType: string) => boolean,
  navigate: NavigateFunction,
  roles: string[],
  openConfirmationModel: (itemName: string, id: string | number) => void,
) => {
  return [
    {
      id: 1,
      key: "title",
      name: t("PROCUREMENT_ANNUAL_PLAN.TABLE.COLUMN.NAME"),
      render: (title: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {title}
          </Text>
        );
      },
    },
    {
      id: 2,
      key: "financialYear",
      name: t("PROCUREMENT_ANNUAL_PLAN.TABLE.COLUMN.YEAR"),
      render: (financialYear: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {financialYear}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: "budget",
      name: t("PROCUREMENT_ANNUAL_PLAN.TABLE.COLUMN.TOTAL_BUDGET"),
      render: (budget: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {budget}
          </Text>
        );
      },
    },
    {
      id: 4,
      key: "createdDate",
      name: t("PROCUREMENT_ANNUAL_PLAN.TABLE.COLUMN.CREATED_DATE"),
      render: (createdDate: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {createdDate}
          </Text>
        );
      },
    },
    {
      id: 5,
      key: "appRefNo",
      name: t("PROCUREMENT_ANNUAL_PLAN.TABLE.COLUMN.APP_REF_NO"),
      render: (appRefNo: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {appRefNo}
          </Text>
        );
      },
    },
    {
      id: 6,
      key: "id",
      name: "",
      render: (id: string | number, row: AnnualProcurementType) => {
        return (
          <div
            className="d-flex gap-3
align-items-center"
          >
            <Button
              type="light"
              size="sm"
              fill="outline"
              onClick={() => {
                navigate(`${ROUTES.DETAILS}/${id}`);
              }}
            >
              {t("PROCUREMENT_ANNUAL_PLAN.TABLE.ACTIONS.DETAILS_BUTTON_TEXT")}
            </Button>
            {getAccess(roles, "PROCUREMENT_HR") ? (
              <div
                onClick={() => {
                  navigate(`${id}`);
                }}
                className="cursor-pointer"
              >
                <IconEdit01 size={20} fill="subtitle1" />
              </div>
            ) : null}
            {getAccess(roles, "PROCUREMENT_HR") ? (
              <div
                onClick={() => {
                  openConfirmationModel(row?.title, id);
                }}
                className="cursor-pointer"
              >
                <IconTrash01 size={20} fill="danger" />
              </div>
            ) : null}
          </div>
        );
      },
    },
  ];
};
